var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1300" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [_c("v-icon", [_vm._v("refresh")]), _vm._v("Movilidad")],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0 px-1" },
            [
              _c(
                "v-container",
                {
                  staticClass: "py-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _vm.form.id_tipo_justificacion != 14
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.tipo_movimientos,
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Tipo de movimiento",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled: _vm.form.editar
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.obtenerTipoJustificaciones()
                                  }
                                },
                                model: {
                                  value: _vm.form.id_tipo_justificacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_tipo_justificacion",
                                      $$v
                                    )
                                  },
                                  expression: "form.id_tipo_justificacion"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_justificacion == 14
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.tipo_movimientos,
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Suspensión",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled: ""
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.obtenerTipoJustificaciones()
                                  }
                                },
                                model: {
                                  value: _vm.form.id_tipo_justificacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_tipo_justificacion",
                                      $$v
                                    )
                                  },
                                  expression: "form.id_tipo_justificacion"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.form.id_tipo_justificacion == 13
                            ? _c("v-select", {
                                attrs: {
                                  items: _vm.tipo_movimientos_r,
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Tipo de movimiento.",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.obtenerTipoJustificacionesR()
                                  }
                                },
                                model: {
                                  value: _vm.form.id_tipo_justificacion_r,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_tipo_justificacion_r",
                                      $$v
                                    )
                                  },
                                  expression: "form.id_tipo_justificacion_r"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 13
            ? _c("retiro", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion_r,
                  funcionario: _vm.funcionario,
                  data: _vm.form
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 1
            ? _c("cambio-item", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion,
                  funcionario: _vm.funcionario,
                  unidades: _vm.unidades,
                  puestos: _vm.puestos,
                  cargos: _vm.cargos,
                  data: _vm.form
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 2
            ? _c("comision-servicio", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion,
                  funcionario: _vm.funcionario,
                  unidades: _vm.unidades,
                  puestos: _vm.puestos,
                  cargos: _vm.cargos,
                  data: _vm.form
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 14
            ? _c("suspencion", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion,
                  funcionario: _vm.funcionario,
                  unidades: _vm.unidades,
                  puestos: _vm.puestos,
                  cargos: _vm.cargos,
                  data: _vm.form
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 11
            ? _c("comision-interinato", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion,
                  funcionario: _vm.funcionario,
                  unidades: _vm.unidades,
                  puestos: _vm.puestos,
                  cargos: _vm.cargos,
                  data: _vm.form
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 7
            ? _c("nueva-asignacion", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion,
                  funcionario: _vm.funcionario,
                  unidades: _vm.unidades,
                  puestos: _vm.puestos,
                  cargos: _vm.cargos,
                  data: _vm.form
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_justificacion == 15
            ? _c("reestructuracion", {
                attrs: {
                  id_tipo_justificacion: _vm.form.id_tipo_justificacion,
                  funcionario: _vm.funcionario,
                  unidades: _vm.unidades,
                  puestos: _vm.puestos,
                  cargos: _vm.cargos,
                  data: _vm.form
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a028048", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a028048","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/dialogs/CrearMovilidad.vue
// module id = null
// module chunks = 